export default __webpack_public_path__ + "static/media/georgi.cd5cad86.jpg";